import * as $ from 'jquery';
import 'bootstrap';
import 'slick';

export class mastheadCarousel {
	private $scope = $('.banner-container .seq');
	// standard options to use for all carousel banners
	private options:any = {
		autoplay: 'true',
		autoplaySpeed: 4000,
		pauseOnHover: false,
		pauseOnFocus: true,
		accessibility: true,
		fade: true,
		dots: true,
		dotsClass: 'seq-pagination slick-dots',
		prevArrow: '<button class="seq-prev"><i class="fa fa-chevron-left"></i></button>',
		nextArrow:  '<button class="seq-next"><i class="fa fa-chevron-right"></i></button>',
		responsive: [
			{
				breakpoint: 768,
				settings: {
					arrows: false
				}
			}
		]
	};

	/**
	 * @function init
	 * init all banners found
	 */
	init(): void {
		let _self = this;
		_self.$scope.each(function(i:number, el:any) {
			_self.initCarousel(el);
		});
	}

	/**
	 * @function initCarousel
	 * init slick on carousel component
	 * retrieve data attributes for some carousel prefs (autoplay related)
	 */
	initCarousel(el:any): void {
		let _self = this;
  	let wrapper = $(el);
  	let carousel = wrapper.find('.seq-canvas');

    let _options = _self.options;

    // get autoplay prefs from data attribute
    if (wrapper.data('autoplay')) {
			_options.autoPlay = (wrapper.data('autoplay'));
		}

		// get autoplay interval prefs from data attribute
		if (wrapper.data('autoplayInterval')) {
			_options.autoPlayInterval = parseInt(wrapper.data('autoplayInterval'));
		}

		// on init slick apply pause button behavior
		carousel.on('init', function(e:any, slick:any){
			_self.initPauseButton(el);
		});

		// init carousel
		carousel.slick(_options);
	}

	/**
	 * @function initPauseButton
	 * toggle play/pause state of carousel on click pause btn
	 * change display icon on pause btn based on current pause state
	 * @param {any}    el [carousel element]
	 */
	initPauseButton(el:any): void {
		let _self = this;
		let wrapper = $(el);
  	let carousel = wrapper.find('.seq-canvas');
		let pauseBtn = wrapper.find('.seq-pause');
		let pauseIcon = pauseBtn.find('i');

		pauseBtn.on('click.pause-carousel', (e:any) => {
			e.preventDefault();
			e.stopPropagation();

			if ("vibrate" in navigator) {
				// vibration API supported
				navigator.vibrate(25);
			}

			if (carousel[0].slick.paused === true) {
				// play carousel if paused
				carousel[0].slick.slickPlay();
			} else {
				// pause carousel if playing
				carousel[0].slick.slickPause();
			}

			pauseIcon.toggleClass('fa-play-circle').toggleClass('fa-pause-circle');
		});
	}

}

let scope:Element = document.querySelector('.banner-container');
if (scope){
	try {
		let bannercarousel = new mastheadCarousel();
		bannercarousel.init();
	} catch(e) {console.error(e);}
}
